module.exports = __webpack_public_path__ + "static/media/profesional.e0302dbb.jpg";